import { Validator } from '@vista-digital/validator';
import { ButtonSize } from '../../../subcomponents/button/types/size';
import { defaultFormConfig, formConfigValidatorSchema } from '../../../subcomponents/form/form/types/config';
import { defaultMemberSignInFormValidationConfig, memberSignInFormValidationConfigValidator } from './validation-config';
export const defaultMemberSignInFormConfig = {
    submitButton: Object.assign(Object.assign({}, defaultFormConfig.submitButton), { size: ButtonSize.Large }),
    cancelButton: Object.assign(Object.assign({}, defaultFormConfig.cancelButton), { show: false }),
    validation: defaultMemberSignInFormValidationConfig
};
export const memberSignInFormConfigValidator = Validator.object(Object.assign(Object.assign({}, formConfigValidatorSchema), { validation: memberSignInFormValidationConfigValidator }));
